/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PartnerOperatorUpdate } from '../../models/partner-operator-update';

export interface UpdatePartnerOperator$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
  
    /**
     * The partner operator update object
     */
    body: PartnerOperatorUpdate
}

export function updatePartnerOperator(http: HttpClient, rootUrl: string, params: UpdatePartnerOperator$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updatePartnerOperator.PATH, 'put');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updatePartnerOperator.PATH = '/partners/operator/{uid}';
